import { lazy, Suspense } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { Spinner } from '@regie/ui'
import { AppShell } from '@/components/layout/AppShell'
import { PublicOnly, RequireAuth } from './guards'

const LoginPage = lazy(() => import('@/features/auth/pages/LoginPage'))
const OpportunitiesPage = lazy(() => import('@/features/opportunities/pages/OpportunitiesPage'))
const PropertiesPage = lazy(() => import('@/features/properties/pages/PropertiesPage'))
const PropertyDetailPage = lazy(() => import('@/features/properties/pages/PropertyDetailPage'))
const PartnersPage = lazy(() => import('@/features/partners/pages/PartnersPage'))
const LinksPage = lazy(() => import('@/features/links/pages/LinksPage'))
const ConversionsPage = lazy(() => import('@/features/conversions/pages/ConversionsPage'))
const AlertsPage = lazy(() => import('@/features/alerts/pages/AlertsPage'))
const AuditPage = lazy(() => import('@/features/audit/pages/AuditPage'))

function PageFallback() {
  return (
    <div className="flex min-h-[50vh] items-center justify-center">
      <Spinner />
    </div>
  )
}

export function AppRoutes() {
  return (
    <Suspense fallback={<PageFallback />}>
      <Routes>
        <Route
          path="/login"
          element={
            <PublicOnly>
              <LoginPage />
            </PublicOnly>
          }
        />

        <Route
          element={
            <RequireAuth>
              <AppShell />
            </RequireAuth>
          }
        >
          <Route index element={<Navigate to="/opportunities" replace />} />
          <Route path="/opportunities" element={<OpportunitiesPage />} />
          <Route path="/properties" element={<PropertiesPage />} />
          <Route path="/properties/:id" element={<PropertyDetailPage />} />
          <Route path="/partners" element={<PartnersPage />} />
          <Route path="/links" element={<LinksPage />} />
          <Route path="/conversions" element={<ConversionsPage />} />
          <Route path="/alerts" element={<AlertsPage />} />
          <Route path="/audit" element={<AuditPage />} />
        </Route>

        <Route path="*" element={<Navigate to="/opportunities" replace />} />
      </Routes>
    </Suspense>
  )
}
